import React, { useEffect } from "react";

import getContentById from "../../../../shared/utils/getContentById";
import _ from "lodash";
import Backgrounds from "../../_partials/Backgrounds/Index";
import TemplateBlock from "../../_partials/TemplateBlock/Index";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg";
import animationScript, {
  animationCleanUp,
} from "./animations";

import assets from "./assets";
import getOptaCountryCode from "../../../../shared/utils/getOptaCountryCode";
import countries from "../../../../../language/de/countries.json";
import { useTranslation } from "react-i18next";
import Image from "../../../../shared/components/Image";
import { WcBgCircle } from "../../../../shared/backgrounds/WcBgCircle/Index";
import {
  findRankStatusChanges,
  findRankStatusChangesV2,
} from "../../../../shared/functions/standing";
import ProgressBar from "../../../../shared/components/ProgressBar";
import { getDynamicLogoPath } from "../../../../shared/utils/functions";
import { MatchScoreWidget } from "../../_partials/MatchScoreWidget/MatchScoreWidgetForBild";
import BildTeamLogo from "../../../../shared/components/Image/BildTeamLogo";
// import outroVideo9x16 from "../../../assets/outros/outro_playoffs_9x16.webm";

require("./style/style.scss");
require("./style/animation.scss");

const translations = {
  Group: "Gruppe",
};

const StandingLabel = () => {
  const { t } = useTranslation();
  return (
    <div className={"table-head"}>
      <div className={"col-pos col"}></div>
      <div className={"col-team col"}></div>
      <div className={"col-points col"}>{t("PL", { keyPrefix: "table" })}</div>
      <div className={"col-points col"}>{t("W", { keyPrefix: "table" })}</div>
      <div className={"col-points col"}>{t("D", { keyPrefix: "table" })}</div>
      <div className={"col-points col"}>{t("L", { keyPrefix: "table" })}</div>
      <div className={"col-diff col"}>{t("GD", { keyPrefix: "table" })}</div>
      <div className={"col-pkt col"}>{t("PTS", { keyPrefix: "table" })}</div>
    </div>
  );
};

const StandingContent = ({
  content,
  className,
  startingIndex,
  linesMarkersByRankType,
}) => {
  const { t } = useTranslation();
  return (
    <div className={"group-table"}>
      <div className={"group-content"}>
        <StandingLabel />
        {content?.map((entry, index) => {
          const properIndex = index + startingIndex;
          const markRowIndex = _.findIndex(linesMarkersByRankType, {
            rowIndex: properIndex + 1,
          });
          const isMarked = markRowIndex > -1;
          return (
            <div
              key={"table-" + index}
              className={`table-row ${isMarked ? "mark-row" : ""} ${className}`}
            >
              <div className={"col-pos col"}>{++index + startingIndex}</div>
              <div className={"col-team col"}>
                <BildTeamLogo className="team-logo" id={entry?.id} />
                {entry?.team}
              </div>
              <div className={"col-points col"}>{entry.GP}</div>
              <div className={"col-points col"}>{entry.W}</div>
              <div className={"col-points col"}>{entry.D}</div>
              <div className={"col-points col"}>{entry.L}</div>
              <div className={"col-diff col"}>{entry.GD}</div>
              <div className={"col-pkt col green-glow"}>{entry.Pts}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const Index = (props) => {
  const refs = {
    player: React.createRef(),
    team: React.createRef(),
  };

  const {
    animation,
    data,
    images: Images,
    apiSetup,
    mode,
    format,
    isTimeline,
  } = props;

  const id = `${_.get(data, "template_name", "")}_${_.get(data, "uuid", "")}`;
  const { t, i18n } = useTranslation();
  const lng = i18n?.language;
  const prepareAnimation = () => {
    prepareVideoBg({ id });
  };

  useEffect(() => {
    let animationReturn = null;
    if (mode === "animation" || mode === "video") {
      if (animation) {
        prepareAnimation();
        animationReturn = animationScript({
          refs,
          data,
          animation,
          mode,
          id,
          format,
          apiSetup,
          templateName: data?.template_name,
        });
      }
    }

    //handle outro video BEGIN
    // if(mode === "video" && !isTimeline) {
    //   const outroVideo = $(`#${id} video.outro-optional-video`);
    //   outroVideo.get(0).addEventListener("loadedmetadata", function() {
    //       const that = this;
    //       setTimeout(()=> {
    //         outroVideo?.css('opacity', 1);
    //         this.currentTime = 0;
    //         that.play();
    //       }, frontendCfg.showOutroAfter)
    //     }, false);
    // }
    //handle outro video END

    return function cleanUp() {
      if (animationReturn) {
        animationCleanUp(animationReturn);
      }
    };
  }, [animation, mode]);

  const templateData = _.get(data, "data");

  const { options, fields, dynamic } = templateData;
  const matchInfo = _.get(dynamic, "matchInfo");
  const homeTeam = matchInfo?.home;
  const awayTeam = matchInfo?.away;
  const standing = _.get(dynamic, "standing");

  const teamSide = getContentById("selectedSide", fields);

  let firstRanking = [];
  let secondRanking = [];
  let thirdRanking = [];
  let fourthRanking = [];
  if (standing.length) {
    firstRanking = standing?.slice(0, 5);
    secondRanking = standing?.slice(5, 10);
    thirdRanking = standing?.slice(10, 15);
    fourthRanking = standing?.slice(15, 20);
  }
  // const linesMarkersByRankType = findRankStatusChanges(findGroup?.ranking, ['Relegation'])
  const linesMarkersByRankType = [];

  return (
    <div
      id={id}
      className={`T_${_.get(data, "template_name", "")} ${animation ? "animation" : ""
        } side-${_.get(dynamic, "teamSide")}`}
    >
      <TemplateBlock class={`${isTimeline ? "" : "template-bild"}`}>
        {
          !isTimeline && <div className="main-header-content">
            <div className="main-header">
              {t("Standings", { keyPrefix: "templates" })}
            </div>
            <MatchScoreWidget
              homeTeam={homeTeam}
              awayTeam={awayTeam}
              matchInfo={matchInfo}
            />
          </div>
        }
        <div
          className={`wc-content wc-content-v2 wc-standing-container`}
        >
          <ProgressBar height={"8px"} />
          <div className="main-content-side">

            <div
              className={`wc-standing-content-container page-1`}
            >
              {firstRanking.length > 0 && (
                <StandingContent
                  content={firstRanking}
                  linesMarkersByRankType={linesMarkersByRankType}
                  startingIndex={0}
                  className={"first-group"}
                />
              )}
            </div>
            <div
              className={`wc-standing-content-container page-2`}
            >
              {secondRanking?.length > 0 && (
                <StandingContent
                  content={secondRanking}
                  linesMarkersByRankType={linesMarkersByRankType}
                  startingIndex={5}
                  className={"second-group"}
                />
              )}
            </div>
            <div className={"wc-standing-content-container page-3"}>
              {thirdRanking.length > 0 && (
                <StandingContent
                  content={thirdRanking}
                  linesMarkersByRankType={linesMarkersByRankType}
                  startingIndex={10}
                  className={"first-group"}
                />
              )}
            </div>

            <div className={"wc-standing-content-container page-4"}>
              <StandingContent
                content={fourthRanking}
                linesMarkersByRankType={linesMarkersByRankType}
                startingIndex={15}
                className={"second-group"}
              />
            </div>
          </div>
        </div>
      </TemplateBlock>
    </div>
  );
};

const getMainBackground = (format, side) => {
  return _.get(assets, `background_1920`);
};

export default Index;
